window.UP = {
    ScrollToFragment: (elementId) => {
        // Try the known main content scroll container first
        const main = document.getElementById('main-content');
        if (main) {
            main.scrollTo({top: 0, behavior: 'smooth'});
            return;
        }

        // Fallback for layouts without main-content (e.g., Viewer)
        let element = document.getElementById(elementId);
        if (element) {
            element.scrollIntoView({behavior: 'smooth'});
        }
    },

    SaveAsFile: (filename, bytesBase64) => {
        const binaryString = atob(bytesBase64);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);
        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        const blob = new Blob([bytes], {type: 'application/octet-stream'});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = filename;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    },

    // Streams a .NET DotNetStreamReference straight into a Blob download, avoiding the
    // base64 round-trip SaveAsFile needs (which can exhaust WASM memory for large files).
    SaveAsFileStream: async (filename, streamReference) => {
        const buffer = await streamReference.arrayBuffer();
        const blob = new Blob([buffer], {type: 'application/octet-stream'});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = filename;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    },

    DrawImageToCanvas: (canvas, imageBytes, imageType) => {
        if (canvas) {
            let ctx = canvas.getContext('2d');

            const byteArray = new Uint8Array(imageBytes);
            const blob = new Blob([byteArray], {type: imageType});

            const url = URL.createObjectURL(blob);

            const image = new Image();
            image.onload = () => {
                canvas.width = image.naturalWidth;
                canvas.height = image.naturalHeight;

                ctx.drawImage(image, 0, 0, canvas.width, canvas.height);

                URL.revokeObjectURL(url);
            };

            image.src = url;
        }
    },

    FocusElement: (elementId) => {
        const element = document.getElementById(elementId);
        if (element) {
            element.focus();
        }
    },

    InsertTextAtCursor: (elementId, text) => {
        const element = document.getElementById(elementId);
        if (!element) return '';

        const start = element.selectionStart ?? element.value.length;
        const end = element.selectionEnd ?? element.value.length;
        const before = element.value.substring(0, start);
        const after = element.value.substring(end);

        element.value = before + text + after;
        element.selectionStart = element.selectionEnd = start + text.length;

        element.dispatchEvent(new Event('input', {bubbles: true}));
        element.dispatchEvent(new Event('change', {bubbles: true}));
        element.focus();

        return element.value;
    }
};
